import { PROJECT_VIEW_ALL, PROJECT_VIEW_ALL_ERROR, PROJECT_CREATE, PROJECT_CREATE_ERROR, PROJECT_ASSIGN, PROJECT_ASSIGN_ERROR, GET_PROJECT } from './type';

const initialState = {
    projects: [],
    projectsError: null,
    projectCreated: null,
    projectCreatedError: null,
    projectAssigned: null,
    projectAssignedError: null,
    errorMessage: null,
    successMessage: null,
    project: {},
}

export const projectReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case PROJECT_VIEW_ALL:
            return {
                ...state,
                projects: payload,
                projectsError: null,
                projectCreated: null,
                projectCreatedError: null,
                projectAssigned: null,
                projectAssignedError: null,
                errorMessage: null,
            };
        case PROJECT_VIEW_ALL_ERROR:
            return { ...state, projectsError: payload }
        case GET_PROJECT:
            return { ...state, project: payload }
        case PROJECT_CREATE:
            return { ...state, projectCreated: payload };
        case PROJECT_CREATE_ERROR:
            return { ...state, errorMessage: payload }
        case PROJECT_ASSIGN:
            return { ...state, projectAssigned: payload };
        case PROJECT_ASSIGN_ERROR:
            return { ...state, projectAssignedError: payload };
        default:
            return state
    }
}